<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name" />

    <!-- Page Contents -->
    <sui-page-contents>
      <sui-panel :title="$t('MSG_TXT_DEFAULT_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_ID')"
                :disabled="true"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-show="!isPopTypeModify"
                v-model.trim="siteData.siteId"
                maxlength="100"
                :disabled="false"
                :readonly="false"
                @keyup="onKeyUpInput"
              />
              <sui-text-field
                v-show="isPopTypeModify"
                v-model.trim="siteData.siteId"
                :disabled="false"
                :readonly="true"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COB_CD')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-show="!isPopTypeModify"
                v-model.trim="siteData.bukrsNumber"
                :disabled="false"
                :readonly="false"
                maxlength="4"
              />
              <sui-text-field
                v-show="isPopTypeModify"
                v-model.trim="siteData.bukrsNumber"
                :disabled="false"
                :readonly="true"
                maxlength="4"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_NAT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="siteData.nationCode"
                codeId="COD_NAT"
                :defaultOption="'select'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.siteName"
                maxlength="50"
                :disabled="false"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_ABBR')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.siteAbbreviationName"
                maxlength="25"
                :disabled="false"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_ABBR_EN')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.siteEnglishAbbreviationName"
                maxlength="25"
                :disabled="false"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GNRZ_AREA')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="siteData.generalizationAreaCode"
                :codeId="'COD_GNRZ_AREA'"
                :defaultOption="'select'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_BIZ_SECT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="siteData.businessSectorDivisionCode"
                codeId="COD_BIZ_SECT_DIV"
                :defaultOption="'select'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_USE_YN')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-radio
                v-model="siteData.siteInfoUseYn.key"
                value="Y"
              >
                Yes
              </sui-radio>
              <sui-radio
                v-model="siteData.siteInfoUseYn.key"
                value="N"
              >
                No
              </sui-radio>
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel
        :title="$t('MSG_TXT_ADD_INFO')"
        sticky
      >
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CURC_CD')"
                :disabled="true"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="siteData.currencyCode"
                codeId="COD_CURC"
                :defaultOption="'select'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_LANG')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-lang-select
                :selected="siteData.langId"
                :pageId="this.$options.name"
                :defaultOption="'select'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.representativeUserName"
                maxlength="25"
                :disabled="false"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TZONE_AREA')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="siteData.timezoneDivisionCode"
                codeId="COD_TZONE_DIV"
                :defaultOption="'select'"
                @list-clicked="onClickTimezonList"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TZONE_GMT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-custom-select
                :selected="siteData.timezoneId"
                :option-list="timezoneGMTOptions"
                :defaultOption="'select'"
                :initialSelectedIndex="1"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ADDR')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-11">
              <sui-text-field
                v-model.trim="siteData.siteAddress"
                maxlength="250"
                :disabled="false"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_TEL')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.siteTelNumber"
                maxlength="10"
                :disabled="false"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ARRAY_ORDER')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.arrayalOrder"
                :disabled="false"
                :readonly="false"
                mask="number"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CRNO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="siteData.corpRegNumber"
                maxlength="10"
                :disabled="false"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_DETAIL_CNTN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-11">
              <textarea
                v-model.trim="siteData.siteContent"
                maxlength="1000"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_border"
            @click="onClose"
          >
            {{ $t("MSG_BTN_LIST") }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-show="isPopTypeModify"
            v-permission:delete="this.$options.name"
            type="button"
            class="comm_btn_border"
            @click="onDelete"
          >
            {{ $t("MSG_BTN_DEL") }}
          </sui-button>
          <sui-button
            v-permission:update="this.$options.name"
            type="button"
            class="comm_btn_solid"
            @click="onSave"
          >
            {{ $t("MSG_BTN_SAVE") }}
          </sui-button>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00017', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      isPopTypeModify: false,
      timezoneGMTOptions: [],
      searchFieldOldText: '',
      siteData: {
        siteId: '',
        siteName: '',
        siteAbbreviationName: '',
        siteEnglishAbbreviationName: '',
        businessSectorDivisionCode: { key: '', label: '' },
        nationCode: { key: '', label: '' },
        generalizationAreaCode: { key: '', label: '' },
        langId: { key: '', label: '' },
        timezoneId: { key: '', label: '' },
        timezoneName: { key: '', label: '' },
        timezoneDivisionCode: { key: '', label: '' },
        currencyCode: { key: '', label: '' },
        siteTelNumber: '',
        siteAddress: '',
        corpRegNumber: '',
        representativeUserName: '',
        siteContent: '',
        bukrsNumber: '',
        arrayalOrder: '',
        siteInfoUseYn: { key: 'N', label: '' },

        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
      },
    };
  },
  mounted() {
    this.init(utils.getParameter(this, 'siteId'));
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    makeSnapshot() {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const dataParams = utils.reduce(this.siteData, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});
      return dataParams;
    },
    /** ***************************************************************************
      이벤트 영역
      ***************************************************************************** */
    onSave() {
      this.saveSite();
    },
    onClose() {
      this.listSitePageMove();
    },
    onDelete() {
      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, this.deleteSite);
    },
    onClickTimezonList(objTimezoneDivCode) {
      this.siteData.timezoneId.key = '';
      this.searchTimezoneGMT(objTimezoneDivCode.key);
    },
    /** ***************************************************************************
      함수 영역 : 사용자 정의 함수
      ***************************************************************************** */
    init(sSiteId) {
      if (utils.isEmpty(sSiteId) === false) {
        this.isPopTypeModify = true;
        this.siteData.siteId = sSiteId;
        this.searchSite(this.siteData.siteId);
      } else {
        this.isPopTypeModify = false;
        this.reset();
      }
    },
    searchSite(sSiteId) {
      http.request(this.$options.name, 'DTS_CMY_00019', {
        path: {
          'site-id': utils.trim(sSiteId),
        },
      }).then(res => {
        const has = Object.prototype.hasOwnProperty;
        utils.forEach(res.data, (value, key) => {
          if (utils.has(this.siteData, key)) {
            if (has.call(this.siteData[key], 'key')) {
              utils.set(this.siteData, key, { key: utils.trim(value), label: '' });
            } else {
              utils.set(this.siteData, key, utils.trim(value));
            }
          }
        });

        this.saveSnapshot(this.makeSnapshot());

        // timezoneGMT 조회
        this.searchTimezoneGMT(this.siteData.timezoneDivisionCode.key);
        // console.log(res);
      }).catch(error => {
        console.log(error);
      });
    },
    searchTimezoneGMT(sTimezoneDivCode) {
      http.request(this.$options.name, 'DTS_CMZ_00078', {
        path: {
          'timezone-div-code': utils.trim(sTimezoneDivCode),
        },
      }).then(res => {
        const tempOptions = [];
        utils.forEach(res.data, item => {
          tempOptions.push({
            key: item.timezoneId,
            label: item.timezoneName,
          });
        });

        this.timezoneGMTOptions = tempOptions;
      });
    },
    saveSite() {
      // form validation
      if (!this.formValidate(this.siteData)) {
        return false;
      }
      const dataParams = this.makeSnapshot();

      let sDataserviceId = 'DTS_CMY_00016';
      if (this.isPopTypeModify) {
        sDataserviceId = 'DTS_CMY_00017';
      }

      http.request(this.$options.name, sDataserviceId, { // dataservices reg.
        path: {
          'site-id': utils.trim(this.siteData.siteId),
        },
        data: dataParams,
      }).then(res => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
          this.listSitePageMove('Y');
        });
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    deleteSite() {
      http.request(this.$options.name, 'DTS_CMY_00018', {
        path: {
          'site-id': this.siteData.siteId,
        },
      }).then(res => {
        utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, () => {
          this.listSitePageMove('Y');
        });

      }).catch(error => {
        console.log(error);
      });
    },
    listSitePageMove(sSearchYn) {
      // utils.goPage('PGE_CMY_00015', { siteId: this.siteData.siteId});
      this.$emit('onChangeMain', sSearchYn);
    },
    formValidate(formData) {
      let isVaildate = true;

      const objMsgList = {
        siteId: this.$t('MSG_TXT_SITE_ID'),
        bukrsNumber: this.$t('MSG_TXT_COB_CD'),
        nationCode: this.$t('MSG_TXT_NAT'),
        siteName: this.$t('MSG_TXT_SITE_NM'),
        siteAbbreviationName: this.$t('MSG_TXT_SITE_ABBR'),
        siteEnglishAbbreviationName: this.$t('MSG_TXT_SITE_ABBR_EN'),
        generalizationAreaCode: this.$t('MSG_TXT_GNRZ_AREA'),
        businessSectorDivisionCode: this.$t('MSG_TXT_BIZ_SECT'),
        siteInfoUseYn: this.$t('MSG_TXT_USE_SEL'),

        currencyCode: this.$t('MSG_TXT_CURC_CD'),
        langId: this.$t('MSG_TXT_LANG'),
        timezoneDivisionCode: this.$t('MSG_TXT_TZONE_AREA'),
        timezoneId: this.$t('MSG_TXT_TZONE_GMT'),
      };

      const isSelectType = [
        'nationCode',
        'generalizationAreaCode',
        'businessSectorDivisionCode',
        'siteInfoUseYn',
        'currencyCode',
        'langId',
      ];

      const has = Object.prototype.hasOwnProperty;
      utils.forEach(objMsgList, (value, key) => {// eslint-disable-line
        let tempValue = formData[key];
        if (has.call(formData[key], 'key')) {
          tempValue = formData[key].key;
        }

        if (utils.isEmpty(utils.trim(tempValue))) {
          if (utils.indexOf(isSelectType, key) !== -1) {
            utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), objMsgList[key]));
          } else {
            utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), objMsgList[key]));
          }
          isVaildate = false;

          // TODO break;
          return false;
        }
      });


      if (formData.bukrsNumber.length > 4) { // 에러 방지
        isVaildate = false;
      }

      return isVaildate;
    },
    reset() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.siteData, (values, key) => {
        if (has.call(this.siteData[key], 'key')) {
          this.siteData[key] = { key: ' ', label: '' };
        } else {
          this.siteData[key] = '';
        }
      });

      this.siteData.siteInfoUseYn.key = 'Y';
      this.timezoneGMTOptions = [];

      this.saveSnapshot(this.makeSnapshot());
    },
    onKeyUpInput() {
      // 영어, 숫자만 가능
      const searchFieldNewText = this.siteData.siteId;

      if (!utils.isEngNum(searchFieldNewText) && !utils.isEmpty(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_ONLY_ENGLISH_NUMBER'), null, () => {
          this.siteData.siteId = this.searchFieldOldText;
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
  },
};
</script>
<style scoped>
</style>
